import { render, staticRenderFns } from "./Asilage.vue?vue&type=template&id=57cdfeea&"
import script from "./Asilage.vue?vue&type=script&lang=js&"
export * from "./Asilage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cdfeea')) {
      api.createRecord('57cdfeea', component.options)
    } else {
      api.reload('57cdfeea', component.options)
    }
    module.hot.accept("./Asilage.vue?vue&type=template&id=57cdfeea&", function () {
      api.rerender('57cdfeea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/Asilage.vue"
export default component.exports